export const THEME_LIGHT_MODE = 'theme_light_mode'
export const THEME_DARK_MODE = 'theme_dark_mode'
export const DISABLE_MEMBERS_AREA = 'disable_members_area'
export const MEMBERS_PAGE_HOME = 'members_page_home'
export const DISABLE_HEROSPARK_LOGO = 'deactivate_copyright'
export const DISABLE_MEMBER_AREA_REFUND = 'disable_member_area_refund'
export const VIDEO_WATERMARK = 'video_watermark'
export const CONTENT_REPORT = 'content_report'
export const MEMBERS_PAGE_COURSE_CONTENTS = 'members_page_course_contents'
// Flag específica do fluxo de cancelamento (rollout separado da flag
// `downsell`, que gateia a recuperação de carrinho no ecommerce).
export const DOWNSELL = 'subscription_downsell'
export const MEMBERS_PAGE_MESSAGES = 'members_page_messages'
export const MEMBERS_PAGE_CERTIFICATES = 'members_page_certificates'
export const STRONG_PASSWORD_POLICY = 'strong_password_policy'
export const ALLOW_COURSE_CONTENT_DOWNLOAD = 'allow_course_content_download'
export const EDM_PAY = 'edm_pay'
export const MEMBERS_AREA_FEATURED_PRODUCT = 'members_area_featured_product'
export const PUSH_NOTIFICATIONS_STUDENTS = 'push_notifications_students'

export const FEATURES = [
  THEME_LIGHT_MODE,
  THEME_DARK_MODE,
  DISABLE_MEMBERS_AREA,
  MEMBERS_PAGE_HOME,
  DISABLE_HEROSPARK_LOGO,
  DISABLE_MEMBER_AREA_REFUND,
  VIDEO_WATERMARK,
  CONTENT_REPORT,
  MEMBERS_PAGE_COURSE_CONTENTS,
  DOWNSELL,
  MEMBERS_PAGE_MESSAGES,
  MEMBERS_PAGE_CERTIFICATES,
  STRONG_PASSWORD_POLICY,
  ALLOW_COURSE_CONTENT_DOWNLOAD,
  EDM_PAY,
  MEMBERS_AREA_FEATURED_PRODUCT,
  PUSH_NOTIFICATIONS_STUDENTS,
] as const
